// custom cells for the table
import Actions from "./Cells/Actions";
import Name from "./Cells/Name";
import RedirectUri from "./Cells/RedirectUri";
import Token from "./Cells/Token";

type Col = {
	id: string;
	Cell: (transaction: any) => JSX.Element | null;
	label: string;
	align?: "center" | "left" | "right";
};

const cols: Col[] = [
	{
		id: "name",
		Cell: Name,
		label: "Nombre",
		align: "left"
	},
	{
		id: "uri",
		Cell: RedirectUri,
		align: "left",
		label: "Redirect uri"
	},
	{
		id: "id",
		Cell: Token,
		align: "left",
		label: "Token"
	},

	{
		id: "actions",
		Cell: Actions,
		align: "right",
		label: ""
	}
];

export default cols;
